import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import './index.css';
import './App.css';

const PRELOAD_ERROR_RELOAD_KEY = 'finbuffer:preload-error-reloaded';

window.addEventListener('vite:preloadError', (event) => {
  try {
    if (sessionStorage.getItem(PRELOAD_ERROR_RELOAD_KEY) === 'true') return;
    sessionStorage.setItem(PRELOAD_ERROR_RELOAD_KEY, 'true');
  } catch (error) {
    console.error('Could not check the page-load recovery state.', error);
    return;
  }

  event.preventDefault();
  window.location.reload();
});

const root = document.getElementById('root')!;
const application = (
  <React.StrictMode>
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  </React.StrictMode>
);

if (root.dataset.prerendered === 'true') {
  hydrateRoot(root, application);
} else {
  createRoot(root).render(application);
}
